export const ACTION_CODE = 'TRAININGS' + '_ACTION';
